import { render } from "./TableLoading.vue?vue&type=template&id=45dab6f6&scoped=true"
import script from "./TableLoading.vue?vue&type=script&lang=js"
export * from "./TableLoading.vue?vue&type=script&lang=js"

import "./TableLoading.vue?vue&type=style&index=0&id=45dab6f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45dab6f6"]])

export default __exports__